export const ensureField = <T>(key: keyof T) => key;
